import { useRandomUserGenerator } from './useRandomUserGenerator';

export const useGenerateRandomName = () => {
    const { generateRandomUser } = useRandomUserGenerator();

    const generateName = () => {
        const user = generateRandomUser();
        return {
            givenName: user.firstName,
            familyName: user.lastName,
            email: user.email,
        };
    };

    return { generateName };
};
